module.exports = __webpack_public_path__ + "img/sol_cap4.1b344f3c.png";